/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// =================Material UI==================
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

// =================Highcharts===================
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// ==================Style&IMG===================
import './style.scss';
import 'cal-heatmap/cal-heatmap.css';

// ==================HOOKS===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

// ==================Actions===================
import { setQualityDatePickerDateFrom, setQualityDatePickerDateTo, setQualityHighcharts } from '../../../actions/metadata';
import { fetchQualityData } from '../../../actions/dataAPI';
import { globalConfig } from '../../../configuration/config';

function Quality() {
  // ===============Dispatch=====================
  const dispatch = useDispatch();
  // ============State Elements==================
  const datePickerQualityDateFrom = useSelector((state) => state.metadata.data.quality.dateFrom);
  const datePickerQualityDateTo = useSelector((state) => state.metadata.data.quality.dateTo);
  const saveFullData = useSelector((state) => state.metadata.data.saveFullData);
  const stationFullData = useSelector((state) => state.metadata.data.stationFullData);
  const currentDate = useSelector((state) => state.metadata.data.currentDate);
  const qualityData = useSelector((state) => state.metadata.data.quality.qualityData);
  const qualityHighcharts = useSelector((state) => state.metadata.data.quality.qualityHighcharts);

  // ==============Handlers======================
  function handleChangeDateFrom(value) {
    const valuetransform = `${value.$d.toString().substring(0, 15)} 00:00:00 GMT+0000`;
    dispatch(setQualityDatePickerDateFrom(new Date(valuetransform).toISOString()));
  }

  function handleChangeDateTo(value) {
    const valuetransform = `${value.$d.toString().substring(0, 15)} 00:00:00 GMT+0000`;
    dispatch(setQualityDatePickerDateTo(new Date(valuetransform).toISOString()));
  }

  function handleFetchNewData() {
    const newDateTo = datePickerQualityDateTo.substring(0, 10);
    const newDateFrom = datePickerQualityDateFrom.substring(0, 10);
    dispatch(fetchQualityData(
      stationFullData[0].marker,
      newDateFrom,
      newDateTo,
      globalConfig.config.REACT_APP_NODE_URL,
      globalConfig.config.REACT_APP_GLASS_API,
    ));
  }

  // ==============function================
  // function to mofify date format
  function dateForQuality(date) {
    const modify = new Date(date);
    modify.setDate(modify.getDate() - 1);
    let dd = modify.getDate();
    let mm = modify.getMonth() + 1;
    const yyyy = modify.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    const modifyDate = `${yyyy}-${mm}-${dd}`;
    return modifyDate;
  }

  // function to modify data and display quality plot
  function qualityCheckPlot(data) {
    const obsHave = [];
    const epochCompl = [];
    const cycSlips = [];
    const mp1 = [];
    const mp2 = [];
    let firstDate = '';
    const mp1Temp = [];
    const mp2Temp = [];
    const obsHaveL2 = [];

    firstDate = data[0].reference_date.substring(0, 10);
    firstDate = Date.UTC(
      firstDate.substring(0, 4),
      firstDate.substring(5, 7) - 1,
      firstDate.substring(8, 10),
    );
    for (let i = 0; i < data.length; i += 1) {
      obsHave.push(data[i].qc_report_summary.obs_have * 100 / data[i].qc_report_summary.obs_expt);
      cycSlips.push(data[i].qc_report_summary.cyc_slps);
      for (let j = 0; j < data[i].qc_report_summary.qc_constellation_summary.length; j += 1) {
        for (let k = 0;
          k < data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_c.length;
          k += 1) {
          const path = data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_c;
          if ((((path[k].obsnames.name === 'C1') || (path[k].obsnames.name === 'C1C') || (path[k].obsnames.name === 'C1XC')) && (data[i].qc_report_summary).qc_constellation_summary[j].constellation.name === 'GPS')) {
            mp1Temp.push(path[k].cod_mpth);
          }
          if ((path[k].obsnames.name === 'P2' || path[k].obsnames.name === 'C2P' || path[k].obsnames.name === 'C2W') && (data[i].qc_report_summary.qc_constellation_summary[j].constellation.name === 'GPS')) {
            mp2Temp.push(path[k].cod_mpth);
          }
        }
        if (data[i].qc_report_summary.qc_constellation_summary[j].constellation.name === 'GPS') {
          const epochFloat = (data[i].qc_report_summary.qc_constellation_summary[j].epo_have * 100 / data[i].qc_report_summary.qc_constellation_summary[j].epo_expt);
          epochCompl.push(Math.round(epochFloat * 100) / 100);
          for (let l = 0; l < data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l.length; l += 1) {
            const path = data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l;
            if (path[l].obsnames.name === 'L2W') {
              obsHaveL2.push(data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_have * 100 / data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_expt);
              break;
            }
            else if (path[l].obsnames.name === 'L2X') {
              obsHaveL2.push(data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_have * 100 / data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_expt);
              break;
            }
            else if (path[l].obsnames.name === 'L2C') {
              obsHaveL2.push(data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_have * 100 / data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_expt);
              break;
            }
            else if (path[l].obsnames.name === 'L2P') {
              obsHaveL2.push(data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_have * 100 / data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_expt);
              break;
            }
            else if (path[l].obsnames.name === 'L2') {
              obsHaveL2.push(data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_have * 100 / data[i].qc_report_summary.qc_constellation_summary[j].qc_observation_summary_l[l].user_expt);
              break;
            }
            else {
              console.log('no data to display');
            }
          }
        }
      }
      if (mp1Temp.length > 0) {
        const sum = mp1Temp.reduce((a, b) => a + b);
        const avg = sum / mp1Temp.length;
        mp1.push(avg);
      }
      if (mp2Temp.length > 0) {
        const sum = mp2Temp.reduce((a, b) => a + b);
        const avg = sum / mp2Temp.length;
        mp2.push(avg);
      }
    }
    const options = {
      chart: {
        type: 'column',
        zoomType: 'x',
      },
      title: {
        text: '',
      },
      legend: {
        enabled: true,
      },
      xAxis: {

        type: 'datetime',
        labels: {
          format: '{value:%e %b %Y}',
        },
      },
      yAxis: [{
        scrollbar: {
          enabled: false,
        },
        title: {
          text: '',
        },
      },
      ],

      plotOptions: {
        column: {
          pointPadding: 0.1,
          borderWidth: 0,
        },
      },
      tooltip: {

      },
      series: [{
        name: 'Epoch completeness (%)',
        data: epochCompl,
        pointStart: firstDate,
        pointInterval: 24 * 3600 * 1000, // one day
        color: '#048b9a',
        borderRadius: '5px',
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          y: 25, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      }, {
        name: 'Obs have L2 GPS (%)',
        data: obsHaveL2,
        pointStart: firstDate,
        pointInterval: 24 * 3600 * 1000, // one day
        color: '#c7cf00',
        borderRadius: '5px',
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          format: '{point.y:.1f}', // one decimal
          y: 25, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      }, {
        name: 'Obs have all GNSS (%)',
        data: obsHave,
        pointStart: firstDate,
        pointInterval: 24 * 3600 * 1000, // one day
        color: '#095228',
        borderRadius: '5px',
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          format: '{point.y:.1f}', // one decimal
          y: 25, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      }, {
        name: 'Cyc slips (#)',
        data: cycSlips,
        pointStart: firstDate,
        pointInterval: 24 * 3600 * 1000, // one day
        color: '#e1e0e0',
        borderRadius: '5px',
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          y: 25, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      }, {
        name: 'Mp1 (cm)',
        data: mp1,
        pointStart: firstDate,
        pointInterval: 24 * 3600 * 1000, // one day
        color: '#FFE4E1',
        borderRadius: '5px',
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          format: '{point.y:.1f}', // one decimal
          y: 25, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      }, {
        name: 'Mp2 (cm)',
        data: mp2,
        pointStart: firstDate,
        pointInterval: 24 * 3600 * 1000, // one day
        color: '#1d4851',
        borderRadius: '5px',
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          format: '{point.y:.1f}', // one decimal
          y: 25, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      }],
    };
    dispatch(setQualityHighcharts(options));
  }

  // ==============Cycle life==============
  // whan launching page fetch data for date selection to display plot
  useEffect(
    () => {
      if (saveFullData) {
        if (stationFullData[0].date_to === null) {
          const newDateTo = dateForQuality(currentDate.substring(0, 10));
          dispatch(setQualityDatePickerDateTo(newDateTo));
          const modify = new Date(newDateTo);
          modify.setDate(modify.getDate() - 1);
          const newDateFrom = dateForQuality(modify);
          dispatch(setQualityDatePickerDateFrom(newDateFrom));
          dispatch(fetchQualityData(
            stationFullData[0].marker,
            newDateFrom,
            newDateTo,
            globalConfig.config.REACT_APP_NODE_URL,
            globalConfig.config.REACT_APP_GLASS_API,
          ));
        }
        else {
          const newDateTo = dateForQuality(stationFullData[0].date_to.substring(0, 10));
          dispatch(setQualityDatePickerDateTo(newDateTo));
          const newDateFrom = dateForQuality(newDateTo);
          dispatch(setQualityDatePickerDateFrom(newDateFrom));
          dispatch(fetchQualityData(
            stationFullData[0].marker,
            newDateFrom,
            newDateTo,
            globalConfig.config.REACT_APP_NODE_URL,
            globalConfig.config.REACT_APP_GLASS_API,
          ));
        }
      }
    },
    [],
  );

  // when state qualityData value change launch function to update plot
  useEffect(
    () => {
      try {
        if (qualityData.length !== 0) {
          qualityCheckPlot(qualityData);
        }
      }
      catch {
        console.log('no data to display');
      }
    },
    [qualityData],
  );
  return (
    <>
      <div className="metatitle"><span>Quality Check</span></div>
      <div className="quality--container">
        <div id="datepickerrange">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
              <DatePicker
                label="Range date start"
                value={dayjs(datePickerQualityDateFrom)}
                format="YYYY.MM.DD"
                onChange={(value) => handleChangeDateFrom(value)}
              />
              <DatePicker
                label="Range date end"
                value={dayjs(datePickerQualityDateTo)}
                format="YYYY.MM.DD"
                onChange={(value) => handleChangeDateTo(value)}
              />
              <button className="quality--button" type="button" onClick={handleFetchNewData}>Submit</button>
            </DemoContainer>
          </LocalizationProvider>
        </div>
        <div className="quality--highcharts">
          <HighchartsReact highcharts={Highcharts} options={qualityHighcharts} />
        </div>
      </div>
    </>
  );
}

export default Quality;
